import {Component, Input, Output, EventEmitter} from "@angular/core";
import {debounceTime} from "rxjs/operators";
import {ControlValueAccessor, DefaultValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'micro-date-picker',
  templateUrl: './date-picker.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DatePickerComponent
    }
  ]
})
export class DatePickerComponent implements ControlValueAccessor {

  dateRegex = /(\d+)-(\d+)-(\d+)/;
  timeRegex = /(\d+):(\d+)/;

  _date: Date;

  @Input()
  infinite: boolean;

  @Output() infiniteChange: EventEmitter<boolean> = new EventEmitter();

  @Input()
  allowInfinite: boolean = true;

  @Output() allowInfiniteChange: EventEmitter<boolean> = new EventEmitter();

  @Input() set date(value: Date) {
    if (typeof value === 'string' && value) {
      try {
        this._date = new Date(value);
      } catch (e) {
        this._date = undefined;
      }
      if (!this._date) {
        if (this.dateRegex.test(value)) {
          var matches = this.dateRegex.exec(value);
          var year = parseInt(matches[1]);
          var month = parseInt(matches[2].replace('0', '')) - 1;
          var day = parseInt(matches[3].replace('0', ''));
          this._date.setFullYear(year, month, day);
        } else if (this.timeRegex.test(value)) {
          var matches = this.timeRegex.exec(value);
          var hour = parseInt(matches[1]);
          var minute = parseInt(matches[2]);
          this._date.setHours(hour, minute);
        }
      }
    } else {
      this._date = !!value ? new Date(value) : undefined;
    }
    this._dateEpoch = this._date?.getTime();
    this.onChange(this._date);
    this.dateEpochChange.emit(this._dateEpoch);
  }

  get date(): Date {
    return this._date;
  }

  _dateEpoch: number;

  @Input() set dateEpoch(value: number) {
    if (value) {
      this._date = new Date(value);
      this._dateEpoch = value;
    } else {
      this._date = undefined;
      this._dateEpoch = undefined;
    }
    this.onChange(this._date);
    this.dateEpochChange.emit(value);
  }

  get dateEpoch(): number {
    return this._dateEpoch;
  }

  @Output() dateEpochChange: EventEmitter<number> = new EventEmitter();

  @Input()
  placeholder: string;

  @Input()
  disabled: boolean = false;

  onChange = (userId) => {};
  onTouched = () => {};
  touched = false;


  constructor() {
    //this.dateAdapter.setLocale("en-ZA");
  }

  writeValue(date: any): void {
    this.date = date;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  clear(): void {
    this.dateEpoch = undefined;
  }

  onInfiniteChange() {
    this.infiniteChange.emit(this.infinite);
  }
}
